import { Grid, Typography } from "@mui/material";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import MxTypography from "@rf-l1/MxTypography";
import useValidateExplicitField from "../../hooks/useValidateExplicitField";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

const LegalStatus = () => {
  const {
    validationDocuments: { legal_status }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };
  return (
    <Grid container item xs={3.5} rowGap={1}>
      <Grid item xs={12}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyFormKeys.file_legal_status}
          label={"Estatus jurídico"}
          maxSize={3}
          minSize={0}
          disabled={legal_status?.disabled!}
          typeKey={CValidationDocumentKeys.LegalStatus}
        />
      </Grid>
      <Grid item xs={12}>
        <MxFormL3TextDateField
          withreacthookform={1}
          name={CPropertyFormKeys.date_file_legal_status}
          label="Fecha de emisión"
          disabled={legal_status?.disabled}
        />
      </Grid>
    </Grid>
  );
};

export default LegalStatus;
